import React from "react";
import DateHelper from "../../DateHelper/DateHelper";
import { format } from "date-fns";

class CancellationRulesDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    function compare(a, b) {
      if (a.code < b.code) {
        return -1;
      }
      if (a.code > b.code) {
        return 1;
      }
      return 0;
    }

    var sorted_cancelation_rules =
      this.props.row.cancellation_rules.sort(compare);
    var cancellation_rules = [];

    for (let step = 0; step < sorted_cancelation_rules.length; step++) {
      if (step < 4) {
        cancellation_rules.push(
          <li key={sorted_cancelation_rules[step].id}>
            {sorted_cancelation_rules[step].code} -{" "}
            {sorted_cancelation_rules[step].time_value} {I18n.t("days")}
          </li>
        );
      } else if (step === 4) {
        cancellation_rules.push(
          <li key='additional-crs'>
            <i>... {`${this.props.row.cancellation_rules.length - 4} ${I18n.t('more')}`}</i>
          </li>
        );
      };
    }

    if (cancellation_rules && cancellation_rules.length > 0) {
      return <ul style={{ marginBottom: 0 }}>{cancellation_rules}</ul>;
    } else {
      return <div>{I18n.t("none")}</div>;
    }   
  }
}

export default CancellationRulesDataType;
